import el from "@cypherpotato/el";
import { PlanBadge } from "../../components/badge";
import { Button, PrimaryButton } from "../../components/button";
import { Icon } from "../../components/icon";
import { ExternalLink } from "../../components/link";
import { MutedText, Paragraph } from "../../components/text";
import { displayAlert } from "../../ui/alert";
import { formatCurrency, formatDate } from "../../ui/format";
import { cond } from "../../util";

export function showAccountPlanDialog(subscription, onSelect) {
    displayAlert({
        title: subscription.plan === "Free" ? "Subscribe to a plan" : "Change plan",
        type: "account-plan-alert",
        dialogSize: "medium",
        message: el(".account-plan-dialog",
            Paragraph(
                "Upgrades are charged now, discounting the unused days of your current plan. Downgrades take effect at the next renewal, on ",
                formatDate(subscription.cycleEnd),
                ". ",
                ExternalLink("Compare all plan resources", "/dashboard/plan")
            ),
            el(".account-plan-grid",
                subscription.plans.map(item =>
                    el(".account-plan-card",
                        {
                            classList: [item.plan === subscription.plan && "current"]
                        },
                        el(".account-plan-card-header",
                            PlanBadge(item.plan),
                            item.plan === subscription.plan && MutedText("Current plan")
                        ),
                        el(".account-plan-price",
                            el("strong", formatCurrency(item.monthlyPrice)),
                            MutedText("/month")
                        ),
                        el("ul",
                            ({
                                Pro: ["Advanced models", "5% commission", "Unlimited collections", "2 GB of included storage", "2 days of conversation retention", "Priority support"],
                                Max: ["All models", "No commission", "Unlimited collections", "20 GB of included storage", "30 days of conversation retention", "Dedicated support"]
                            })[item.plan]?.map(feature =>
                                el("li", Icon("check-line"), feature)
                            )
                        ),
                        el(".account-plan-action",
                            cond(
                                [item.plan === subscription.plan && subscription.isCancellationPending, () => el.fragment(
                                    MutedText(`Ends on ${formatDate(subscription.cycleEnd)}`),
                                    PrimaryButton(`Keep ${item.plan}`, {
                                        onClick() {
                                            this.closest("dialog").dismiss();
                                            onSelect(item.plan);
                                        }
                                    })
                                )],
                                [item.plan === subscription.plan, () => el.fragment(
                                    MutedText(`Renews on ${formatDate(subscription.cycleEnd)}`),
                                    Button("Current plan", { disabled: true })
                                )],
                                [item.plan === subscription.pendingPlan, () => el.fragment(
                                    MutedText(`Starts on ${formatDate(subscription.cycleEnd)}`),
                                    Button("Scheduled", { disabled: true })
                                )],
                                [item.isDowngrade, () => el.fragment(
                                    MutedText(`Starts on ${formatDate(subscription.cycleEnd)}, nothing due today`),
                                    Button(`Switch to ${item.plan}`, {
                                        onClick() {
                                            this.closest("dialog").dismiss();
                                            onSelect(item.plan);
                                        }
                                    })
                                )],
                                [true, () => el.fragment(
                                    el("span", el("strong", formatCurrency(item.dueToday)), " due today"),
                                    PrimaryButton(`${subscription.plan === "Free" ? "Subscribe to" : "Upgrade to"} ${item.plan}`, {
                                        onClick() {
                                            this.closest("dialog").dismiss();
                                            onSelect(item.plan);
                                        }
                                    })
                                )]
                            )
                        )
                    )
                )
            )
        ),
        buttons: [
            {
                label: "Cancel"
            }
        ]
    });
}
